import {defineAsyncComponent} from 'vue';

const AccountTransferSlipVoucherDetail = defineAsyncComponent(() =>
  import('@/views/distribution/accountTransferSlip/accountTransferSlipDetail/AccountTransferSlipVoucherDetail.vue'),
);
const VoucherListDetail = defineAsyncComponent(() =>
  import('@/views/distribution/voucherList/voucherListDetail/VoucherListDetail.vue'),
);

const cashReceiptDetail = defineAsyncComponent(() => import('@/views/cash/cashReceipt/CashReceiptDetail.vue'));
const cashPaymentDetail = defineAsyncComponent(() => import('@/views/cash/cashPayment/CashPaymentDetail.vue'));

const distributionSellingAssetDetail = defineAsyncComponent(() =>
  import('@/views/distribution/distributionSellingAsset/DistributionSellingAssetDetail.vue'),
);

const subOrgReportList = defineAsyncComponent(() =>
  import('@/views/summary/receiveSubOrgReport/reportList/SubOrgReportList.vue'),
);
const reportRequest = defineAsyncComponent(() =>
  import('@/views/summary/receiveSubOrgReport/reportRequest/ReportRequest.vue'),
);
const reportReject = defineAsyncComponent(() =>
  import('@/views/summary/receiveSubOrgReport/reportRequest/ReportReject.vue'),
);
const reportRequestMode = defineAsyncComponent(() =>
  import('@/views/summary/receiveSubOrgReport/reportRequest/ReportRequestMode.vue'),
);
const voucherPostedPopup = defineAsyncComponent(() =>
  import('@/views/distribution/voucherList/voucherListDetail/VoucherPostedPopup.vue'),
);
const popupHideShowColumn = defineAsyncComponent(() => import('@/views/hideShowColumn/HideShowColumn.vue'));

export function registerBusinessPopup(app) {
  app.component('AccountTransferSlipVoucherDetail', AccountTransferSlipVoucherDetail);
  app.component('CashReceiptDetail', cashReceiptDetail);
  app.component('CashPaymentDetail', cashPaymentDetail);
  app.component('DistributionSellingAssetDetail', distributionSellingAssetDetail);

  app.component('VoucherListDetail', VoucherListDetail);
  app.component('SubOrgReportList', subOrgReportList);
  app.component('ReportRequest', reportRequest);
  app.component('ReportReject', reportReject);
  app.component('ReportRequestMode', reportRequestMode);
  app.component('VoucherPostedPopup', voucherPostedPopup);
  app.component('HideShowColumn', popupHideShowColumn);
}
